var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef } from "react";
import ProfileTableBody from "./ProfileTableBody";
import di from "../../di/serviceLocator";
import Loader from "@frameworks/shared-library/components/Loader";
import ToggleSwitch from "@frameworks/web/components/generic/SwitchButton/Switch";
import Arrows from "@frameworks/web/components/generic/TableHeaderArrows";
import { getSortedData } from "@domains/utils/sort";
var HeadTitles = [
    {
        title: "",
        key: "",
        arrows: false,
    },
    {
        title: "Client Tier",
        key: "ClientTier",
        arrows: false,
    },
    {
        title: "AUM",
        key: "AUA",
        arrows: true,
        sortType: true,
        sortKey: "aua",
    },
    {
        title: "Customer Count",
        key: "CustomerCount",
        className: "text-end",
        arrows: false,
    },
    {
        title: "High Engaged",
        key: "HighEngaged",
        arrows: true,
        sortType: true,
        sortKey: "highEngaged",
        sortDataType: "string",
    },
    {
        title: "Avg. Product Depth",
        key: "AvgProductDepth",
        className: "text-end",
        arrows: true,
        sortType: true,
        sortKey: "productDepth",
    },
    {
        title: "Avg.Rating",
        key: "AvgRating",
        arrows: true,
        sortType: true,
        sortKey: "rating",
    },
];
var ProfileAccordionTable = function () {
    var _a = __read(React.useState(true), 2), summarizeToggle = _a[0], setSummarizeToggle = _a[1];
    var _b = __read(React.useState([]), 2), clientRatingSummaryEntity = _b[0], setClientRatingSummaryEntity = _b[1];
    var _c = __read(React.useState({}), 2), sortState = _c[0], setSortState = _c[1];
    var _d = __read(React.useState(false), 2), loader = _d[0], setLoader = _d[1];
    var accordingChild = useRef(null);
    var applySortingAccordingKey = function (sortType, sortKey, sortDataType) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setClientRatingSummaryEntity(function (clientRatingSummaryEntity) {
                if (clientRatingSummaryEntity && clientRatingSummaryEntity.length > 0) {
                    clientRatingSummaryEntity = clientRatingSummaryEntity.map(function (record) {
                        var _a;
                        if (record.clientList && ((_a = record.clientList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            record.clientList = getSortedData(record.clientList, sortType, sortKey, sortDataType);
                        }
                        return record;
                    });
                }
                return clientRatingSummaryEntity;
            });
            return [2 /*return*/];
        });
    }); };
    var getClientRatingSummaryEntity = function () {
        setLoader(true);
        var req = {
            page: 1,
            pageSize: 10000,
        };
        di.profile
            .getClientRatingSummaryEntity(req)
            .then(function (resp) {
            setClientRatingSummaryEntity(resp);
            setLoader(false);
        })
            .catch(function (error) {
            setClientRatingSummaryEntity([]);
            setLoader(false);
        });
    };
    React.useEffect(function () {
        getClientRatingSummaryEntity();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "profile-accordion-table-block container" },
            React.createElement("div", { className: "pt-3 summarized-block d-flex align-items-center pb-4" },
                React.createElement(ToggleSwitch, { id: "summarize", name: "summarize", checked: summarizeToggle, onChange: setSummarizeToggle, small: true, className: "sales-toggle" }),
                React.createElement("span", { className: "DMSanN_14_400 txt_blackOne1 summaries-val-block ps-2" }, "Summarize Values")),
            React.createElement("table", { className: "profile-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null, HeadTitles.map(function (items) {
                        return (React.createElement("th", { className: "DMSan_14_500 txt_primaryGrey " + (items === null || items === void 0 ? void 0 : items.className) }, (items === null || items === void 0 ? void 0 : items.arrows) ? (React.createElement("div", { className: "d-flex td-arrow", onClick: function () {
                                setSortState(function (sortState) {
                                    sortState.sortKey = items === null || items === void 0 ? void 0 : items.sortKey;
                                    sortState.sortDataType = items === null || items === void 0 ? void 0 : items.sortDataType;
                                    sortState.sortType = !sortState.sortType;
                                    applySortingAccordingKey(sortState.sortType, sortState.sortKey, sortState.sortDataType);
                                    // if (accordingChild)
                                    //   accordingChild.current.applySorting(
                                    //     sortState
                                    //   );
                                    return sortState;
                                });
                            } },
                            React.createElement(Arrows, { title: items.title }))) : (items.title)));
                    }))),
                loader && (React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 8 },
                            React.createElement("div", { className: "position-relative mt-3 pb-5" },
                                React.createElement(Loader, { className: "common-loader" })))))),
                !loader &&
                    clientRatingSummaryEntity &&
                    clientRatingSummaryEntity.length > 0 &&
                    clientRatingSummaryEntity.map(function (x, index) {
                        return (React.createElement(ProfileTableBody, { sortState: sortState, setSortState: setSortState, clientTier: x.clientTier, summarizeToggle: summarizeToggle, toatalAUA: x.totalAua, totalCustomerCount: x.totalCustomerCount, finalHighEngaged: x.highEngaged, totalAvgProductDepth: x.totalProductDepth, totalAvgRating: x.totalRating, clientList: x.clientList ? x.clientList : [], selectedClientTierId: index, setClientRatingSummaryEntity: setClientRatingSummaryEntity, ref: accordingChild }));
                    })))));
};
export default ProfileAccordionTable;
